<div class="toast-container">
  @for (toast of toasts(); track toast) {
    <div
      role="button"
      tabindex="0"
      (keydown.enter)="clickToast(toast)"
      (keydown.space)="$event.preventDefault(); clickToast(toast)"
      [@slideInOut]
      class="bank_alert__container toast"
      [ngClass]="toast.type"
      (click)="clickToast(toast)"
      fxLayout.lt-lg="column"
      fxLayout.gt-md="row"
    >
      @if (isDesktop) {
        <div class="toast-icon-background">
          <mat-icon class="toast-icon">{{ toast.icon }}</mat-icon>
        </div>
        <div fxLayout="column" fxFlex>
          <span class="toast-title font_12 weight_500">{{ toast.message | translate }}</span>
          <span class="toast-subtitle font_10 weight_400">{{ toast.subtitle | translate }}</span>
          @if (toast.displayedButtons?.length > 0) {
            <div class="toast-buttons">
              @for (button of toast.displayedButtons; track button) {
                @if (button.fixed) {
                  @if (!button.onlyIcon && button.label) {
                    <button
                      class="page_header__action_button"
                      [matButton]="dsVariant(button.color)"
                      [class]="dsClass(button.color)"
                      (click)="button.click()"
                    >
                      @if (button.icon) {
                        <mat-icon class="material-symbols-rounded">{{ button.icon }}</mat-icon>
                      }
                      {{ button.label | translate }}
                    </button>
                  }
                  @if (!button.label || button.onlyIcon) {
                    <button mat-icon-button class="page_header__icon_button" (click)="button.click()">
                      @if (button.icon) {
                        <mat-icon class="material-symbols-rounded" matTooltip="{{ button.label && (button.label | translate) }}"
                          >{{ button.icon }}
                        </mat-icon>
                      }
                      @if (!button.onlyIcon && button.label) {
                        <span>{{ button.label | translate }}</span>
                      }
                    </button>
                  }
                }
              }
            </div>
          }
        </div>
        <div
          role="button"
          tabindex="0"
          (keydown.enter)="dismissToast(toast)"
          (keydown.space)="$event.preventDefault(); dismissToast(toast)"
          class="toast__close"
          (click)="dismissToast(toast)"
        >
          <mat-icon>close</mat-icon>
        </div>
      }
      @if (!isDesktop) {
        <div fxLayout="row" class="width-100" fxLayoutAlign="space-between center">
          <div fxLayout="row" fxLayoutGap="16px" class="w-100">
            <div class="toast-icon-background">
              <mat-icon class="toast-icon">{{ toast.icon }}</mat-icon>
            </div>
            <div fxLayout="column" fxLayoutGap="8px">
              <span class="toast-title" ngClass.lt-md="font_14 weight_600">{{ toast.message | translate }}</span>
              <span class="toast-subtitle" ngClass.lt-md="font_11 weight_400">{{ toast.subtitle | translate }}</span>
            </div>
          </div>
          <div
            role="button"
            tabindex="0"
            (keydown.enter)="dismissToast(toast)"
            (keydown.space)="$event.preventDefault(); dismissToast(toast)"
            class="toast__close"
            (click)="dismissToast(toast)"
          >
            <mat-icon>close</mat-icon>
          </div>
        </div>
        @if (toast.displayedButtons?.length > 0) {
          @if (toast.displayedButtons?.length) {
            <div fxLayout="column" fxFlex>
              <div class="toast-buttons">
                @for (button of toast.displayedButtons; track button) {
                  @if (button.fixed) {
                    @if (!button.onlyIcon && button.label) {
                      <button
                        class="page_header__action_button"
                        [matButton]="dsVariant(button.color)"
                        [class]="dsClass(button.color)"
                        (click)="button.click()"
                      >
                        @if (button.icon) {
                          <mat-icon class="material-symbols-rounded">{{ button.icon }}</mat-icon>
                        }
                        {{ button.label | translate }}
                      </button>
                    }
                    @if (!button.label || button.onlyIcon) {
                      <button mat-icon-button class="page_header__icon_button" (click)="button.click()">
                        @if (button.icon) {
                          <mat-icon class="material-symbols-rounded" matTooltip="{{ button.label && (button.label | translate) }}"
                            >{{ button.icon }}
                          </mat-icon>
                        }
                        @if (!button.onlyIcon && button.label) {
                          <span>{{ button.label | translate }}</span>
                        }
                      </button>
                    }
                  }
                }
              </div>
            </div>
          }
        }
      }
    </div>
  }
</div>
